import { CameraHelper, DirectionalLight, Object3D } from 'three'
import { getParentScene } from '../../utils/threejs'

const DebugDirectionalLightCamera = () => (obj: Object3D) => {
  const scene = getParentScene(obj)
  const light = obj.children[0] as DirectionalLight
  const camHelp = new CameraHelper(light.shadow.camera)
  scene?.add(camHelp)
}

export default DebugDirectionalLightCamera
